// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    box-sizing: border-box;
  }
  
  .pagination span {
    margin: 0 5px;
    cursor: pointer;
  }
  
  .pagination span.active {
    background-color: lightgrey;
    padding: 10px 15px;
    font-weight: bold;
  }
  
  .pagination span.ellipsis {
    margin: 0 6px;
    cursor: default !important;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/pagination/Pagination.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,2BAA2B;IAC3B,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,0BAA0B;EAC5B","sourcesContent":[".pagination {\n    display: flex;\n    justify-content: center;\n    margin-top: 20px;\n    box-sizing: border-box;\n  }\n  \n  .pagination span {\n    margin: 0 5px;\n    cursor: pointer;\n  }\n  \n  .pagination span.active {\n    background-color: lightgrey;\n    padding: 10px 15px;\n    font-weight: bold;\n  }\n  \n  .pagination span.ellipsis {\n    margin: 0 6px;\n    cursor: default !important;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
